import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  allAnalytics: null,
  analyticDetails: null,
  updateAnalyticDetails: null,
}

const getters = {
  allAnalytics() {
    const url = '/AnalyticAdmin/Analytics'
    return axios.get(url)
  },
  analyticDetails(analyticId) {
    const url = `/AnalyticAdmin/${analyticId}`
    return axios.get(url)
  },
}

const saves = {
  updateAnalyticDetails(analytic) {
    const url = '/AnalyticAdmin/UpdateAnalyticDetails'
    return axios.put(url, analytic)
  },
}

export default class AnalyticManagementService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
